import "./ConfirmationForm.scss";

import React, { useMemo } from "react";
import { useBemBlock } from "../../../../common/utils/bemContext/bemContextHook";
import { cl } from "@ngd-web/lv-utils/ui/classNames";
import { SubscriptionPreferencesFormInputGroupComponent } from "../_shared/formInputGroup/SubscriptionPreferencesFormInputGroupComponent";
import { SubscriptionPreferencesFormButtonComponent } from "../_shared/formButton/SubscriptionPreferencesFormButtonComponent";
import { TextIconComponent } from "../../../../common/icons/TextIconComponent";
import { SubscriptionPreferencesHrComponent } from "../_shared/hr/SubscriptionPreferencesHrComponent";
import { useDispatch } from "react-redux";
import {
    reIdentifyUserOnSubscriptionPreferencesAction,
    reSendCodeUserOnSubscriptionPreferencesAction,
    submitCodeOnSubscriptionPreferencesAction,
} from "../subscriptionPreferences/subscriptionPreferencesActions";

const i18n = {
    sentTo: "The code is sent to +43 677 987 654 32.",
    change: "Change number",
    smsCode: "SMS code (4 digits)",
    submit: "Submit",
    noCode: "Didn't receive the code?",
    resend: "Resend it",
};

export function ConfirmationFormComponent({ className }) {
    const [bl, el] = useBemBlock("usmConfirmationForm");

    const dispatch = useDispatch();
    const [changeNumber, resendCode, submit] = useMemo(
        () => [
            (e: MouseEvent) => {
                e.stopPropagation();
                e.preventDefault();
                dispatch(reIdentifyUserOnSubscriptionPreferencesAction);
                return false;
            },
            () => dispatch(reSendCodeUserOnSubscriptionPreferencesAction),
            () => dispatch(submitCodeOnSubscriptionPreferencesAction),
        ],
        []
    );

    return (
        <div className={cl(className, bl())}>
            <div className={el("sent-message")}>
                {i18n.sentTo}{" "}
                <a
                    href="/UserManagement"
                    className={el("change-button")}
                    onClick={changeNumber as any}>
                    {i18n.change}
                </a>
            </div>

            <SubscriptionPreferencesFormInputGroupComponent
                inputHolderClassName={el("input")}
                label={i18n.smsCode}
                IconElement={TextIconComponent}
            />

            <SubscriptionPreferencesFormButtonComponent
                className={el("submit")}
                title={i18n.submit}
                onClick={submit}
            />

            <SubscriptionPreferencesHrComponent className={el("hr")} />

            <div className={el("no-code")}>
                {i18n.noCode}{" "}
                <span className={el("resend")} onClick={resendCode}>
                    {i18n.resend}
                </span>{" "}
                <span className={el("timer")}>(0:37)</span>
            </div>
        </div>
    );
}
